import React, { useEffect } from 'react'
import styled from 'styled-components'

import breakpoints from '../../constants/breakpoints'
import { ContentImage, Slide } from '../../types'
import { getNextSkipRoute } from '../../utils'

import SlideContainer from '../Layout/SlideContainer'
import Readspeaker from '../../components/Readspeaker'
import LinkButton from '../LinkButton'

interface Props {
  align?: string
  title: string
  contentImage: ContentImage[]
  button: string
  nextLink: string
  routeIndex?: string
  routes: Slide[]
  onSkipRoute: (path: string) => void
}

const ExplanationWithImage: React.FC<Props> = ({
  align,
  title,
  contentImage,
  button,
  nextLink,
  routeIndex,
  routes,
  onSkipRoute,
}) => {
  useEffect(() => {
    const nextRoute = routeIndex && getNextSkipRoute(routeIndex, routes)
    nextRoute && onSkipRoute(nextRoute.path)
  }, [])

  return (
    <SlideContainer>
      <Content className="text-formatted" $align={align}>
        <h1>{title}</h1>
        <Readspeaker />

        {contentImage.length > 0 &&
          contentImage.map((item: ContentImage, index) => (
            <div key={index}>
              {item.text && (
                <Description
                  key={`description-${index}`}
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              )}
              {item.image && (
                <Image key={`img-${index}`} src={item.image.src} alt={item.image.alt} />
              )}
            </div>
          ))}

        {nextLink && (
          <Next>
            <LinkButton to={nextLink}>{button}</LinkButton>
          </Next>
        )}
      </Content>
    </SlideContainer>
  )
}

const Content = styled.div<{ $align: string | undefined }>`
  text-align: ${({ $align }) => ($align ? $align : 'center')};
  max-width: 100%;

  @media (min-width: ${breakpoints.sm}) {
    max-width: 700px;
  }
`

const Description = styled.div`
  margin: 0 0 10px;
`

const Image = styled.img`
  margin-top: 35px;
  display: block;
  width: 100%;
  height: auto;
`

const Next = styled.div`
  margin-top: 35px;
  width: 100%;
`

export default ExplanationWithImage
